import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Inject, Injectable } from '@angular/core';
import { filter, map } from 'rxjs/operators';

import { apiResponse } from 'src/app/core/api/api.actions';
import { responseRequestType } from 'src/app/core/api/api.utilities';
import { ApiRequestType } from 'src/app/shared/enums/api.enums';
import { DOCUMENT } from 'src/app/feature/injection-token/document';
import { WINDOW } from 'src/app/feature/injection-token/window';
import { AppState } from 'src/app/app.state';

/**
 * Handles any sort of requesting of locale-related information.
 */
@Injectable()
export class ApplicationConfigEffects {
	/**
	 * Our constructor
	 * @param document The document object
	 * @param window Window Object
	 * @param actions$ The actions stream.
	 */
	constructor(
		@Inject(DOCUMENT) private document: Document,
		@Inject(WINDOW) private window: Window,
		private actions$: Actions,
		private store: Store<AppState>
	) {}

	updateCssVariables$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(apiResponse),
				filter(responseRequestType(ApiRequestType.GET_APPLICATION_CONFIG)),
				map((action) => {
					if (action.isOk) {
						try {
							const cssVariables = JSON.parse(action.response.SETTINGS[0].css_variables);
							const root = this.document.documentElement;

							// Append CSS Variables to DOM
							Object.keys(cssVariables).forEach(function mapKeyToCssVariable(key) {
								root.style.setProperty('--' + key, cssVariables[key]);
							});
						} catch (ignore) {}
					}
				})
			),
		{ dispatch: false }
	);
}
